import React, { useState, useEffect } from "react";

import Navbar from "../../components/Navbar/navbar";
import EVCIFilters from "../../components/EvciEds/evci-filters";
import EvciTableData from '../../components/EvciEds/evci-eds-tabledata'
import EvciEdsTreeData from '../../components/EvciEds/evci-eds-tree-data'
import filterJsonData from '../../components/EvciEds/evci-filters.json'
import measureListData from '../../components/EvciEds/measure-list.json'
import PageInfoDialog from "../../components/PageInfoDialog/PageInfoDialog";
import { PAGE_INFO_DATA } from "../../utils/pageInfoData";

function EvciEds() {

    // Set all filters to empty string for initial state
    const getInitialFilters = () => ({
        Country: 'US',
        State: 'California',
        Site: 'Baker100048',
        OnelineDiagram: 'Switchboard',
        RefreshRate: '5'
    });
    const [selectedFilters, setSelectedFilters] = useState(getInitialFilters());

    // Separate state for complete filters with list and measurements
    const [completeFilters, setCompleteFilters] = useState(null);

    // State for refresh timer and last refresh time
    const [lastRefreshTime, setLastRefreshTime] = useState(new Date());
    const [refreshCounter, setRefreshCounter] = useState(0);

    useEffect(() => {
        // Only update complete filters when ALL five dropdowns are selected
        if (
            selectedFilters.Country &&
            selectedFilters.State &&
            selectedFilters.Site &&
            selectedFilters.OnelineDiagram &&
            selectedFilters.RefreshRate
        ) {
            // Get device list from filterJsonData
            const deviceList =
                filterJsonData?.[selectedFilters.Country]?.[selectedFilters.State]?.[selectedFilters.Site]?.[selectedFilters.OnelineDiagram]?.list || [];

            // Get measurements from measureListData
            const measurements = measureListData?.measurement || [];

            const filtersWithData = {
                ...selectedFilters,
                list: deviceList,
                measurements: measurements
            };

            setCompleteFilters(filtersWithData);
            setLastRefreshTime(new Date());
            console.log("Complete filters updated in parent (EvciEds):", filtersWithData);
        } else {
            // Clear complete filters if not all dropdowns are selected
            setCompleteFilters(null);
        }
    }, [selectedFilters.Country, selectedFilters.State, selectedFilters.Site, selectedFilters.OnelineDiagram, selectedFilters.RefreshRate, refreshCounter]);

    // Set up refresh timer based on RefreshRate
    useEffect(() => {
        if (!completeFilters || !selectedFilters.RefreshRate) return;

        const refreshInterval = parseInt(selectedFilters.RefreshRate) * 60 * 1000; // Convert minutes to milliseconds

        const timer = setInterval(() => {
            setRefreshCounter(prev => prev + 1); // This will trigger the data refresh
            setLastRefreshTime(new Date());
            console.log(`Auto-refreshing every ${selectedFilters.RefreshRate} minute(s)`);
        }, refreshInterval);

        return () => clearInterval(timer);
    }, [completeFilters, selectedFilters.RefreshRate]);

    return (
        <>
            {/* Page Info Icon - Fixed Position Top Right */}
            <PageInfoDialog pageData={PAGE_INFO_DATA['evci-eds']} pageKey="evci-eds" />
            
            <Navbar />
            <EVCIFilters
                filters={selectedFilters}
                onFilterChange={setSelectedFilters}
                lastRefreshTime={lastRefreshTime}
            />
            {completeFilters && (
                <EvciEdsTreeData
                    selectedFilters={completeFilters}
                    refreshTrigger={refreshCounter}
                />
            )}
            <EvciTableData />
        </>
    );

}

export default EvciEds;
